<!-- 支付订单 -->
<template>
	<div class="wrap">

		<Header backgroundColor="#F2F2F2"></Header>

		<Subheader title="购物车" :hide="true" :hide2="false" :hideAlert="true" :hideStep="false"></Subheader>
		
		<!-- 新增/修改 地址弹窗-->
		<address-add v-model="dialogFormVisible" :add_id="currentEditId" @save="addressAddSave"></address-add>

		<div class="box">
			<div class="recipient-information-wrap">
				<div class="row-between">
					<div class="row-between-leftsidebar">
						<span class="font-1">收件人信息</span>
						<button type="button" class="add-address-btn" @click="currentEditId = 0; dialogFormVisible = true">
							<span>+</span>
							添加新地址
						</button>
					</div>
					<span class="manage-all-addresses" @click="$router.push('/my/my-address')">管理全部地址</span>
				</div>
				<ul class="select-address-list" v-infinite-scroll="getAddressList" style="overflow:auto">
					<li v-for="(item, index) in list" :key="index" @click="selectAddress(index)" :class="{active: listIndex == index}">
						<div class="select-address-sidebar">
							<p class="people-name">{{item.name}}</p>
							<p class="addrss-box">
								<span class="addrss-msg">
									{{item.pro_name}}
									{{item.city_name}}
									{{item.county_name}}
									{{item.street_name}}
									{{item.detail}}
								</span>
								<span class="people-phone-num">{{item.phone}}</span>
							</p>
						</div>
						<div class="select-address-btn-box">
							<button type="button" @click="delAddress(item.id)">删除</button>
							<button type="button" @click="currentEditId = item.id; dialogFormVisible = true">修改</button>
						</div>
					</li>
				</ul>
			</div>
			<div class="product">
				<p class="top-row">
					<span>商品</span>
					<span>规格</span>
					<span>数量</span>
					<span>金额总计</span>
				</p>
				<div class="center-module">
					<div class="product-module">
						<div class="product-msg-box">
							<img :src="info.goods_info.cover" class="product-img">
							<div class="product-msg-sidebar">
								<p class="product-name">{{info.goods_info.name}}</p>
								<!-- <p class="product-msg-red">支持7天无理由退换货</p> -->
							</div>
						</div>
						<div class="align-center-box">
							<div class="item-msg-box">
								<p class="tag-row" v-for="(item, index) in info.goods_info.item_list.goods_spec_arr" :key="index">{{item[0]}}：{{item[1]}}</p>
								<!-- <p class="tag-row">尺码：标准版(2G内存 ...</p> -->
							</div>
							<div class="item-msg-box">
								x{{params.num}}
								<!-- <el-input-number v-model="params.num" :min="1" :max="info.goods_info.item_list.stock">
								</el-input-number> -->
							</div>
							<div class="item-msg-box">
								<span class="price">¥ {{goodsMoney}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="bottom-module">
					<div class="bottom-row-between">
						<label class="font-2">配送方式</label>
						<p class="max-row">
							<span>普通配送</span>
						</p>
						<p class="row">
							快递： {{freight > 0 ? `￥${freight}` : '免邮'}}
							<img src="../../assets/back-icon.png" class="back-icon">
						</p>
					</div>
					<div class="bottom-row-between" v-if="discountMoney > 0">
						<label class="font-2">订单优惠</label>
						<p class="max-row">
							<span class="red-color">￥{{discountMoney}}</span>
						</p>
					</div>
				</div>
				<div class="price-details-module">
					<p class="price-details-label">价格明细</p>
					<div class="price-total-row-between">
						<div class="price-total-row-left">
							商品总价
							<span>共{{goodsNum}}件宝贝</span>
						</div>
						<span class="price-total-num">￥{{goodsMoney}}</span>
					</div>
					<ul class="price-details-list">
						<li>
							<div class="price-details-item-left">
								<img src="../../assets/icon-41.png">
								可用{{info.total_integral_money * 100}}积分抵用{{info.total_integral_money}}元
							</div>
							<div class="price-details-item-right">
								<!-- 减￥8.00 -->
								<span v-if="params.integral_order == 0">未使用</span>
								<span v-else>减￥{{params.integral_order / 100}}</span>
								<img src="../../assets/icon-42.png">
							</div>
							<el-select :value="integralIndex" @change="bindIntegralChange" placeholder="请选择" class="select-comp">
								<el-option
									v-for="(item, index) in integralList"
									:key="index"
									:label="item.title"
									:value="index">
								</el-option>
							</el-select>
						</li>
						<li>
							<div class="price-details-item-left">
								<img src="../../assets/icon-40.png">
								<!-- 三张抵用券 -->
								抵用券
							</div>
							<div class="price-details-item-right">
								<!-- 减￥8.00 -->
								<span v-if="info.coupon_list.length <= 1">无可用抵用券</span>
								<span v-else-if="couponIndex <= 0">未使用</span>
								<span v-else>减 ￥{{info.coupon_list[couponIndex].amount}}</span>
								<img src="../../assets/icon-42.png">
							</div>
							<el-select :value="couponIndex" :disabled="info.coupon_list.length <= 1" @change="bindCouponChange" placeholder="请选择" class="select-comp">
								<el-option
									v-for="(item, index) in info.coupon_list"
									:key="index"
									:label="item.title"
									:value="index">
								</el-option>
							</el-select>
						</li>
						<!-- <li>
							<div class="price-details-item-left">
								<img src="../../assets/icon-39.png">
								新人首次下单立即8元
							</div>
							<div class="price-details-item-right">
								减￥8.00
								<img src="../../assets/icon-42.png">
							</div>
						</li> -->
					</ul>
					<div class="price-total-row-between-end">
						<span>合计</span>
						<span>￥{{totalMoney}}</span>
					</div>
				</div>
				<div class="payment-module">
					<p class="payment-label">支付方式</p>
					<ul class="payment-list">
						<li @click="pay_type = 5" :class="{active: pay_type == 5}">
							<img src="../../assets/type-2.png">微信支付
						</li>
						<li @click="pay_type = 6" :class="{active: pay_type == 6}">
							<img src="../../assets/type-4.png">支付宝支付
						</li>
					</ul>
				</div>
				<div class="box-end">
					<div class="msg-box">
						<div class="row-end">
							实付款: <span class="real-payment">￥<span>{{totalMoney}}</span></span>
						</div>
						<p class="row-end" v-if="params.add_id > 0 && listIndex > -1">
							寄送至: 
							{{list[listIndex].pro_name}}
							{{list[listIndex].city_name}}
							{{list[listIndex].county_name}}
							{{list[listIndex].street_name}}
							{{list[listIndex].detail}}
						</p>
						<p class="row-end" v-if="params.add_id > 0">收货人：{{list[listIndex].name}} {{list[listIndex].phone}}</p>
					</div>
				</div>
				<div class="btn-box-end">
					<button type="button" @click="createOrderImmediately()">提交订单</button>
				</div>
			</div>
		</div>

		<!-- 删除弹窗 -->
		<el-dialog title="删除宝贝" :visible.sync="del" width="30%" class="del-wrap">
			<span>确认要删除吗？</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="del = false">确定</el-button>
				<el-button @click="del = false">取消</el-button>
			</span>
		</el-dialog>

		<!------------------ 支付弹窗开始 ------------------>
		<el-dialog
			:title="`请使用${pay_type_map[pay_type]}扫码支付`"
			:visible.sync="showPayCode"
			width="300px"
			:before-close="beforeClosePay"
			@close="closedPay()"
			class="pay-wrap"
		>
			<div v-loading="payCodeLoading">
				<div class="pay-wrap-content">
					<canvas ref="paycode"></canvas>
				</div>
				<div class="flex-center-box">
					<span slot="footer" class="dialog-footer">
						<el-button @click="$confirm('确认取消支付？').then(() => showPayCode = false)">取消支付</el-button>
						<el-button type="primary" @click="checkPay()">我已支付</el-button>
					</span>
				</div>
			</div>
		</el-dialog>
		<!------------------ 支付弹窗结束 ------------------>
	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Subheader from '../../components/sub-header.vue';
	import QRCode from 'qrcode';
	import {
		orderConfirmOrderImmediately,
		walletManageWalletInfo,
		userManageGetDeliveryAddressList,
		orderGetGoodsFreight,
		orderCreateOrderImmediately,
    	orderPayOrder,
      	orderGetOrderDetail,
        userManageDelDeliveryAddress,
	} from '../../service/service';
	import AddressAdd from '../../components/address-add.vue';
	export default {
		components: {
			Header,
			Subheader,
			AddressAdd
		},
		data() {
			return {
				username: '',
				phone_number: '',
				region: '',
				region2: '',
				region3: '',
				desc: '',
				del: false, //删除弹窗

				// 商品数量
				num: 1,

				integralList: [{
					integral: -1,
					title: '不使用',
				}, {
					integral: 0,
					title: '全部',
				}, {
					integral: 100,
					title: '100积分抵1元',
				}, {
					integral: 200,
					title: '200积分抵2元',
				}, {
					integral: 500,
					title: '500积分抵5元',
				}, {
					integral: 1000,
					title: '1000积分抵10元',
				}, {
					integral: 5000,
					title: '5000积分抵50元',
				}, {
					integral: 10000,
					title: '10000积分抵100元',
				}],
				integralIndex: 0,

				addressInfo: {
					id: 0
				},
				info: {
					goods_info: {
						item_list: {},
					},
					coupon_list: [],
					total_integral_money: '',
				},
				couponIndex: 0,

				freight: 0,
				goodsNum: 0,
				goodsMoney: 0,
				discountMoney: 0,
				totalMoney: 0,
				
				walletInfo: {},
				
				params: {
					goods_id: 0,  // 商品id
					spec_id: 0,  // 商品多规格的规格id
					num: 1,  // 数量
					act_type: 0,  // 活动类型（0正常购买，1限时秒杀（抢购），2拼团,3折扣）
					act_id: 0,  // 活动id（活动类型act_type>0必传）
					integral_order: 0,  // 积分（抵扣订单的）
					coupon_id: 0,  // 优惠券id
					add_id: 0,  // 收货地址id

					leader_id: 0,  // 参与团的id(为0是新开团)
					share_user: 0,  // 分享人（谁分享给你的）
					pay_city: 0,  // 本次登录的城市
				},
				
				confirmParams: {
					goods_id: 0,  // 商品id
					spec_id: 0,  // 商品多规格的规格id
					num: 1,  // 数量
					act_type: 0,  // 活动类型（0正常购买，1限时秒杀（抢购），2拼团,3折扣）
					act_id: 0,  // 活动id（活动类型act_type>0必传）
				},

				// 地址列表
				page: 1,
				page_num: 20,
				list: [],
				listIndex: -1,
				
				// ----------------- 支付开始 -----------------
				// 已经创建的订单id，
				order_id: 0,
				// 显示支付弹窗
				showPayCode: false,
				payCodeLoading: true,
				// 5 pc（微信扫码）
				// 6 pc（支付宝扫码）
				pay_type: 5, // 默认微信
				pay_type_map: {
					5: '微信',
					6: '支付宝',
				},
				// ----------------- 支付结束 -----------------
				//修改&&新增弹窗
				dialogFormVisible: false,
				currentEditId: 0,
			};
		},
		mounted() {
			const option = this.$route.query;
			option.goods_id = parseInt(option.goods_id || 0);
			option.spec_id = parseInt(option.spec_id || 0);
			option.num = parseInt(option.num || 0);
			option.act_id = parseInt(option.act_id || 0);
			option.act_type = parseInt(option.act_type || 0);
			if (option.goods_id > 0 && option.spec_id > 0 && option.num > 0) {
				this.confirmParams = option;
				this.params = { ...this.params, ...option };
				this.confirmOrderImmediately();
				this.manageWalletInfo();
			}
			this.getAddressList();
			setTimeout(() => {
			}, 2000);
		},
		methods: {
			addressAddSave(success) {
				if (success) {
					this.page = 1;
					this.getAddressList();
				}
			},
			// 确认删除
			delAddress(id) {
				this.$confirm('确认删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userManageDelDeliveryAddress({ id }).then(({code, msg, data}) => {
						if (code == 1) {
							this.page = 1;
							this.getList();
							document.documentElement.scrollTop = 0;
							this.$message.success(msg);
						} else {
							this.$message.info(msg);
						}
					});
				});
			},
			confirmOrderImmediately() {
				// act_type 0正常购买，1限时秒杀（抢购），2拼团,3折扣
				const { act_type } = this.params;
				orderConfirmOrderImmediately(this.confirmParams).then(({code, msg, data}) => {
					if (code == 1) {
						data.total_integral_money = parseFloat(data.goods_discount.order_cash || 0);
						this.integralList = this.integralList.filter(item => item.integral <= 100 * data.total_integral_money);
						data.goods_info.item_list['goods_spec_arr'] = data.goods_info.item_list.goods_spec.split(';;').map(str => str.split('::'))
						let price = 0;
						const itemList = data.goods_info.item_list;
						switch(act_type) {
							case 0: price = parseFloat(itemList.sell_price); break; // 售价
							case 1: price = parseFloat(itemList.seckill_price); break; // 秒杀价（没有秒杀活动=售价）
							case 2: price = parseFloat(itemList.group_price); break; // 拼团价（没有拼团活动=售价
							case 3: price = parseFloat(itemList.discount_price); break; // 折扣价（没有折扣活动=售价）
						}
						let goodsNum = this.params.num;
						let goodsMoney = goodsNum * price;
						let discountMoney = parseFloat(itemList.sell_price) * goodsNum - goodsMoney;
						
						data.coupon_list = [
							{
								id: 0,
								title: '不使用'
							},
							...data.goods_discount.coupon_list.map(item => {
								item.low_amount = parseFloat(item.low_amount);
								item.amount = parseFloat(item.amount);
								return ({
									...item,
									title: `${item.title}满${item.low_amount}减${item.amount}`,
								});
							}).filter(item => goodsMoney >= item.amount),
						];
						this.goodsNum = goodsNum;
						this.goodsMoney = goodsMoney;
						this.totalMoney = goodsMoney;
						this.discountMoney = discountMoney;
						this.info = data;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取钱包
			manageWalletInfo() {
				walletManageWalletInfo().then(({code, msg, data}) => {
					if (code == 1) {
						this.walletInfo = data.detail;
						this.integralList = this.integralList.filter(item => item.integral <= data.detail.integral);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取地址列表
			getAddressList() {
				const {page = 1, page_num = 20} = this;
				const params = { page, page_num };
				userManageGetDeliveryAddressList(params).then(res => {
					if (res.code === 1) {
						const list = res.data.list.map(item => {
							const [first_name, ...last_name] = item.name.split('');
							item['first_name'] = first_name;
							item['last_name'] = last_name.join('');
							return item;
						});
						this.list = page > 1 ? [...this.list, ...list] : list;
						if (list.length === 0) {
							this.$message.info('没有更多数据了');
						} else {
							this.page = this.page + 1;
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取运费
			getGoodsFreight() {
				const params = {
					goods_id: this.params.goods_id,
					num: this.params.num,
					add_id: this.params.add_id,
				};
				orderGetGoodsFreight(params).then(({code, msg, data}) => {
					if (code == 1) {
						this.freight = parseFloat(data.freight);
						this.calculate();
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 创建订单
			createOrderImmediately() {
				if (this.params.add_id == 0 || this.params.add_id.length == 0) {
					return this.$message.warning('请选择收货地址');
				}
				if (this.order_id > 0) {
					return this.pay(data.order_id);
				}
				orderCreateOrderImmediately(this.params).then(({code, msg, data}) => {
					if (code == 1) {
						this.order_id = data.order_id;
						this.pay(data.order_id);
					} else {
						this.$message.error(msg);
					}
				});
			},

			// ------------------ 支付开始 ------------------
			// 支付
			pay(id) {
				// 获取订单支付参数
				const params = {
					order_id: id,
					pay_type: this.pay_type,
				};
				this.payCodeLoading = true;
				this.showPayCode = true;
				orderPayOrder(params).then(({code, msg, data}) => {
					if (code == 1) {
						QRCode.toCanvas(this.$refs['paycode'], data.code_url, { width: 200 }, error =>  {
							if (error) console.error(error);
							console.log('success!');
							this.payCodeLoading = false;
						});
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 验证是否支付
			checkPay() {
				orderGetOrderDetail({order_id: this.order_id}).then(({ code, msg, data }) => {
					if (code == 1) {
						console.log(data.detail);
						if (data.detail.status == 0) {
							this.$message.warning('尚未支付!');
						} else {
							this.$message.success('支付成功!');
							setTimeout(() => {
								this.$router.replace('/my/my-order?status=1');
							}, 1000);
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 取消前提示
			beforeClosePay(done) {
				this.$confirm('确认取消支付？').then(() => done());
			},
			// 取消支付
			closedPay() {
				this.$router.replace('/my/my-order?status=0');
			},
			// ------------------ 支付结束 ------------------

			// 选择收货地址
			selectAddress(index) {
				this.listIndex = index;
				this.params.add_id = this.list[index].id;
				this.getGoodsFreight();
			},

			// 选择积分
			bindIntegralChange(index) {
				this.integralIndex = index;
				const integral = this.integralList[index].integral;
				switch(index) {
					case 0:
						this.params.integral_order = 0;
						break;
					case 1:
						this.params.integral_order = Math.min(this.info.total_integral_money * 100, this.walletInfo.integral);
						break;
					default: 
						this.params.integral_order = integral;
				}
				this.calculate();
			},

			// 选择优惠券
			bindCouponChange(index) {
				this.couponIndex = index;
				this.params.coupon_id = this.info.coupon_list[this.couponIndex].id;
				this.calculate();
			},

			// 计算选中价格
			calculate() {
				const { goodsMoney, integralList, integralIndex, info, couponIndex, params, freight }= this;
				const integralMoney = params.integral_order / 100;
				const couponMoney = parseFloat(info.coupon_list[couponIndex].amount || 0);
				this.totalMoney = parseFloat((goodsMoney + freight - integralMoney - couponMoney).toFixed(2));
			},
		}
	}
</script>
<style scoped>
	.wrap {
		width: 100%;
		margin: 140px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #F2F2F2 !important;
	}

	.box {
		width: 1200px;
		display: flex;
		flex-direction: column;
		margin: 20px 0;
	}

	.recipient-information-wrap {
		width: 1200px;
		display: flex;
		flex-direction: column;
		background-color: #F9F9F9;
		border-radius: 8px;
		border: 20px solid #fff;
		box-sizing: border-box;
		margin: 0 auto 20px;
	}

	.row-between {
		width: 100%;
		height: 69px;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.row-between-leftsidebar {
		display: flex;
		align-items: center;
	}

	.font-1 {
		color: #111111;
		font-size: 20px;
		font-weight: bold;
	}

	.add-address-btn {
		width: 122px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		border-radius: 5px;
		color: #111111;
		font-size: 16px;
		margin-left: 30px;
	}

	.add-address-btn>span {
		color: #F2501A;
		margin-right: 7px;
	}

	.manage-all-addresses {
		color: #111111;
		font-size: 16px;
	}

	.select-address-list {
		width: 100%;
		max-height: 200px;
		display: flex;
		flex-direction: column;
		padding: 0 20px 20px 47px;
		box-sizing: border-box;
	}

	.select-address-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.select-address-list>li:last-child {
		margin-bottom: 0;
	}

	.select-address-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.people-name {
		min-width: 93px;
		padding: 0 10px;
		box-sizing: border-box;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #484848;
		font-size: 16px;
		position: relative;
		border-radius: 5px;
		overflow: hidden;
	}

	.addrss-box {
		flex: 1;
		display: flex;
		align-items: center;
		margin-left: 16px;
	}

	.addrss-msg {
		color: #484848;
		font-size: 16px;
	}

	.people-phone-num {
		color: #484848;
		font-size: 16px;
		margin-left: 20px;
	}

	.select-address-btn-box {
		display: flex;
		align-items: center;
		/* display: none; */
	}

	.select-address-btn-box>button {
		font-size: 16px;
		color: #777777;
		margin-right: 20px;
	}

	.select-address-btn-box>button:last-child {
		margin-right: 0;
		color: #F2501A;
	}

	.select-address-list>li.active .people-name {
		border: 1px solid #E63D23;
	}

	.select-address-list>li.active .people-name::after {
		content: "";
		width: 25px;
		height: 25px;
		background: url(../../assets/icon-24.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.select-address-list>li.active .addrss-msg {
		color: #F2501A;
	}

	.select-address-list>li.active .people-phone-num {
		color: #F2501A;
	}

	.select-address-list>li.active .select-address-btn-box {
		display: flex;
	}
	
	.select-address-list>li:hover p,
	.select-address-list>li:hover span{
		color: #F2501A !important;
	}

	.select-address-list>li:hover .select-address-btn-box {
		display: flex;
	}

	.product {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 20px;
	}

	.top-row {
		width: 100%;
		height: 100px;
		background-color: #F9F9F9;
		border-radius: 8px 8px 0 0;
		display: flex;
		align-items: center;
		color: #111111;
		font-size: 20px;
		font-weight: bold;
	}

	.top-row>span:first-child {
		width: 656px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.top-row>span {
		width: 174px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.center-module {
		width: 100%;
		background-color: #FFFFFF;
		border-radius: 0 0 8px 8px;
		display: flex;
		flex-direction: column;
		padding: 34px 0;
	}

	.product-module {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 38px;
	}

	.product-module:last-child {
		margin-bottom: 0;
	}

	.product-msg-box {
		width: 656px;
		display: flex;
		align-items: flex-start;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.product-img {
		width: 151px;
		height: 151px;
		border-radius: 6px;
		object-fit: cover;
		margin-right: 20px;
	}

	.product-msg-sidebar {
		flex: 1;
		height: 151px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.product-name {
		width: 62%;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #000000;
		font-size: 16px;
		margin-bottom: 7px;
	}

	.product-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #666666;
		font-size: 17px;
	}

	.product-msg-red {
		width: 100%;
		color: #F2501A;
		font-size: 14px;
		line-height: 14px;
		margin-top: 7px;
	}

	.align-center-box {
		display: flex;
		align-items: center;
	}

	.item-msg-box {
		width: 174px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 20px 0;
		box-sizing: border-box;
		color: #111111;
		font-size: 16px;
	}

	.tag-row {
		width: 100%;
	}

	.wrap >>>.el-input-number {
		width: 125px !important;
		line-height: 30px !important;
	}

	.el-input-number>>>.el-input::after {
		content: "" !important;
		width: 57px !important;
		height: 30px !important;
		position: absolute !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		border-radius: 50px;
		background-color: #EEEEEE !important;
		z-index: 0 !important;
	}

	.wrap >>>.el-input-number__decrease,
	.wrap >>>.el-input-number__increase {
		top: 50% !important;
		transform: translate(0, -50%) !important;
		width: 30px !important;
		height: 30px !important;
		line-height: 30px !important;
		border-radius: 50% !important;
		border: none !important;
		z-index: 90 !important;
		color: #111111 !important;
		background: #EEEEEE !important;
	}

	.el-input-number>>>.el-input__inner {
		height: 30px !important;
		line-height: 30px !important;
		padding-left: 30px !important;
		padding-right: 30px !important;
		background-color: rgba(0, 0, 0, 0) !important;
		z-index: 9 !important;
		color: #111111 !important;
		font-size: 14px !important;
		border: none !important;
		position: relative !important;
	}

	.wrap >>>.el-input-number__decrease,
	.wrap >>>.el-input-number__increase {
		font-size: 10px !important;
	}

	.bottom-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		padding: 32px 20px;
		box-sizing: border-box;
		border-radius: 0 0 8px 8px;
		margin-bottom: 20px;
	}

	.bottom-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 25px;
	}

	.bottom-row-between:last-child {
		margin-bottom: 0;
	}

	.font-2 {
		width: 160px;
		font-size: 18px;
		color: #111111;
	}

	.max-row {
		flex: 1;
		font-size: 18px;
		color: #484848;
	}

	.row {
		display: flex;
		align-items: center;
		font-size: 20px;
		color: #484848;
	}

	.back-icon {
		width: 10px;
		margin-left: 14px;
	}

	.red-color {
		color: #F2501A;
	}

	.payment-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 5px;
		padding: 17px 23px 23px;
		box-sizing: border-box;
		margin-bottom: 7px;
	}

	.payment-label {
		width: 100%;
		color: #111111;
		font-size: 24px;
		margin-bottom: 30px;
	}

	.payment-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.payment-list>li {
		width: 212px;
		height: 55px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 8px;
		margin-bottom: 8px;
		color: #111111;
		font-size: 16px;
		border: 1px solid #DCDCDC;
		box-sizing: border-box;
	}
	.payment-list>li.active{
		border: 2px solid #F2501A;
	}

	.payment-list>li>img {
		width: 35px;
		height: 35px;
		margin: 14px;
	}

	.btn-box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0 0 30px;
	}

	.btn-box-end>button {
		width: 182px;
		height: 49px;
		line-height: 49px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F2501A;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 23px;
	}

	.box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.msg-box {
		max-width: 284px;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		background-color: #FFFFFF;
		border: 1px solid #E63D23;
		border-radius: 8px;
		padding: 8px 20px;
		box-sizing: border-box;
	}

	.row-end {
		width: 100%;
		text-align: right;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		color: #111111;
		font-size: 14px;
		margin-bottom: 5px;
	}

	.row-end:last-child {
		margin-bottom: 0;
	}

	.real-payment {
		color: #777777;
		font-size: 23px;
	}

	.real-payment>span {
		color: #F2501A;
		font-size: 23px;
		font-weight: bold;
	}

	.wrap >>>.el-dialog__header {
		padding: 15px 17px 15px !important;
		background-color: #F9F9F9 !important;
	}

	.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	.wrap >>>.el-dialog {
		width: 812px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	.wrap >>>.el-dialog__body {
		padding: 36px 0 41px !important;
	}

	.row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 15px;
	}

	.row-start-label {
		width: 141px;
		text-align: right;
		line-height: 40px;
		color: #111111;
		font-size: 18px;
		padding-right: 16px;
		box-sizing: border-box;
	}

	.row-start-label>span {
		margin-right: 6px;
	}

	.row-sidebar {
		width: 205px;
		display: flex;
		align-items: center;
	}

	.select-item {
		width: 174px;
	}

	.flex-end-box {
		margin-left: 141px;
	}

	.form-bottom {
		display: flex;
		align-items: center;
		color: #777777;
		font-size: 15px;
	}

	input[type="checkbox"] {
		width: 14px !important;
		height: 14px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/circle.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 13px;
		margin-top: 1.5px;
	}

	input[type="checkbox"]:checked {
		background: url(../../assets/circle-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.form-btnBox {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.form-btnBox>button {
		width: 104px;
		height: 34px;
		line-height: 34px;
		background-color: #F2501A;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		color: #FFFFFF;
		margin-right: 14px;
	}

	.form-btnBox>button:last-child {
		border: 1px solid #DCDCDC;
		background-color: #FFFFFF;
		color: #777777;
	}

	.del-wrap>>>.el-dialog {
		width: 383px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	.del-wrap>>>.el-dialog__header {
		padding: 28px 32px 20px !important;
		background-color: #FFFFFF !important;
	}

	.del-wrap.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	.del-wrap>>>.el-dialog__body {
		padding: 0 34px 21px !important;
		box-sizing: border-box !important;
	}

	.del-wrap>>>.el-dialog__footer {
		padding: 0 34px 17px !important;
		box-sizing: border-box !important;
		text-align: left !important;
	}

	.del-wrap>>>.el-button {
		height: 30px !important;
		line-height: 30px !important;
		padding: 0 17px !important;
		border-radius: 100px !important;
		font-size: 14px !important;
		font-weight: normal !important;
	}

	.del-wrap>>>.el-button--primary {
		border: none !important;
		background-color: #F2501A !important;
	}

	.price-details-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 5px;
		margin-bottom: 22px;
		padding: 21px 23px;
		box-sizing: border-box;
	}

	.price-details-label {
		width: 100%;
		margin-bottom: 10px;
		font-size: 20px;
		color: #111111;
	}

	.price-total-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.price-total-row-left {
		display: flex;
		align-items: center;
		font-size: 20px;
		color: #111111;
	}

	.price-total-row-left>span {
		margin-left: 25px;
		color: #A7A7A7;
	}

	.price-total-num {
		color: #111111;
		font-size: 16px;
	}

	.price-details-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.price-details-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 13px;
		position: relative;
	}

	.price-details-item-left {
		display: flex;
		align-items: center;
		color: #111111;
		font-size: 20px;
	}

	.price-details-item-left>img {
		width: 42px;
		margin-right: 60px;
	}

	.price-details-item-right {
		color: #F2501A;
		font-size: 16px;
		display: flex;
		align-items: center;
	}

	.price-details-item-right>img {
		width: 8px;
		margin-left: 15px;
	}

	.price-total-row-between-end {
		width: 100%;
		margin-top: 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #111111;
		font-size: 20px;
	}
	.select-comp{
		width: 100%;
		height: 42px;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
	}

	/* ----------------- 支付css ----------------- */
	.pay-wrap>>>.el-dialog {
		width: 383px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	.pay-wrap>>>.el-dialog__header {
		padding: 28px 32px 20px !important;
		background-color: #FFFFFF !important;
	}

	.pay-wrap.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	.pay-wrap>>>.el-dialog__body {
		padding: 0 34px 21px !important;
		box-sizing: border-box !important;
	}

	.pay-wrap>>>.el-dialog__footer {
		padding: 0 34px 17px !important;
		box-sizing: border-box !important;
		text-align: left !important;
	}

	.pay-wrap>>>.el-button {
		height: 32px !important;
		line-height: 32px !important;
		padding: 0 20px !important;
		border-radius: 100px !important;
		font-size: 15px !important;
		font-weight: normal !important;
	}

	.pay-wrap>>>.el-button--primary {
		border: none !important;
		background-color: #F2501A !important;
	}

	.pay-wrap-content {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;    
		margin-bottom: 10px;
	}

	.flex-center-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center; 
		margin-bottom: 20px;
	}
	/* ----------------- 支付css ----------------- */
</style>
